"use client";
import React, { useEffect, useState } from "react";
import {
  Input,
  Option,
  Select,
  Button,
  Dialog,
  Textarea,
  IconButton,
  Typography,
  DialogBody,
  DialogHeader,
  DialogFooter,
} from "@material-tailwind/react";
import { RxCross2 } from "react-icons/rx";
import { getAllProducts } from "@/API/response";
import { Field } from "formik";

export function EditProductModal({ openModal, onClose, submitHua, data }) {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    price: "",
    comparePrice: "",
    category: "",
    brand: "",
    quantity: "",
    topSale: "",
    images: [],
    id: "",
  });
  // console.log("category", data?.category)
  // console.log("brand", data?.brand)
  useEffect(() => {
    setFormData({
      name: data?.name || "",
      description: data?.description || "",
      comparePrice: data?.comparePrice || "",
      price: data?.price || "",
      category: data?.category || "",
      brand: data?.brand || "",
      quantity: data?.quantity || "",
      topSale: data?.topSale || "",
      id: data?._id || "",
      images: Array.isArray(data?.images) ? data.images : [],
    });
  }, [data]);
  // console.log("formData",formData)
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Handle Image Change
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 5 * 1024 * 1024;

    // Check for oversized files
    const oversizedFiles = files.filter((file) => file.size > maxSize);
    if (oversizedFiles.length > 0) {
      alert("Some files are too large. Please upload files smaller than 5 MB.");
      return;
    }

    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...files],
    }));
  };
  // remove image  
  const handleRemoveImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index),
    }));
  };
  const [brandData, setBrandData] = useState([])
  const [isLoader, setIsLoader] = useState(false)
  const getAllBrand = async () => {
    setIsLoader(true)
    const res = await getAllProducts('brand')
    // console.log("get all brand", res)
    setBrandData(res)
    setIsLoader(false)

  }
  useEffect(() => {
    getAllBrand()
  }, []);
  const [categoryData, setCategoryData] = useState([])
  useEffect(() => {
    const getAllCategory = async () => {
      const res = await getAllProducts('category')
      // console.log("get all category", res)
      setCategoryData(res)
    }
    getAllCategory()
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      images: formData.images.map((img) => (img.file ? img.url : img)),
    };
    // console.log("submit time",updatedFormData)
    submitHua(updatedFormData);
    onClose()
  };
  const getDisplayableImages = (images) => {
    return images.map((img) => {
      // Check if it's a File object
      if (img instanceof File) {
        return URL.createObjectURL(img); // Generate preview URL for local file
      }
      return img; // Return the URL directly for already uploaded images
    });
  };
  const displayableImages = getDisplayableImages(formData.images);
  console.log("brand name ",formData?.brand)
  return (
    <>
      <Dialog
        size="sm"
        open={openModal}
        handler={submitHua}
        className="p-2  relative h-full   overflow-hidden overflow-y-auto "
      >
        <form onSubmit={handleSubmit}>
          <DialogHeader className="relative m-0 block">
            <Typography variant="h4" color="blue-gray">
              Edit Product
            </Typography>
            <Typography className="mt-1 font-normal text-gray-600">
              Edit product details to ensure they remain accurate and consistent.
            </Typography>
            <IconButton
              size="sm"
              variant="text"
              className="!absolute right-3.5 top-3.5"
              onClick={onClose}
            >
              <RxCross2 className="h-4 w-4 stroke-2" />
            </IconButton>
          </DialogHeader>

          <DialogBody className="space-y-2 pb-3">
            {/* Product Name */}
            <div>
              <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                Product Name
              </Typography>
              <Textarea
                rows={2}
                color="gray"
                size="lg"
                placeholder="e.g. White Shoes"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleInputChange}
                className="placeholder:opacity-100 focus:!border-t-gray-900"
                containerProps={{
                  className: "!min-w-full",
                }}

              />
            </div>

            {/* Image Upload */}
            <div>
              <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                Product Image
              </Typography>
              <div className="flex gap-4 flex-wrap items-center">

                {displayableImages.map((img, index) =>

                (
                  <div key={index} className="relative flex flex-wrap">
                    <img
                      src={img}
                      alt="Product"
                      className="w-20 h-20 object-cover rounded"
                    />
                    <span
                      onClick={() => handleRemoveImage(index)}
                      className="absolute top-1 right-1 bg-red-500 text-pureWhite text-xs rounded-full px-2 py-1"
                    >
                      X
                    </span>
                  </div>
                )
                )}
                <input type="file" multiple accept="image/*" onChange={handleImageChange} />
              </div>
            </div>

            {/* Price and Compare Price */}
            <div className="flex gap-4">
              <div className="w-full">
                <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                  Compare Price
                </Typography>
                <Input
                  color="gray"
                  size="lg"
                  type="number"
                  placeholder="e.g. 10"
                  name="comparePrice"
                  value={formData.comparePrice}
                  onChange={handleInputChange}
                  className="placeholder:opacity-100 focus:!border-t-gray-900"
                  containerProps={{
                    className: "!min-w-full",
                  }}
                />
              </div>

              <div className="w-full">
                <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                  Price
                </Typography>
                <Input
                  color="gray"
                  size="lg"
                  type="number"
                  placeholder="e.g. $50"
                  name="price"
                  value={formData.price}
                  onChange={handleInputChange}
                  className="placeholder:opacity-100 focus:!border-t-gray-900"
                  containerProps={{
                    className: "!min-w-full",
                  }}
                />
              </div>
            </div>
            <div className="w-full">
              <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                Quantity
              </Typography>
              <Input
                color="gray"
                size="lg"
                type="number"
                placeholder="e.g. $50"
                name="quantity"
                value={formData.quantity}
                onChange={handleInputChange}
                className="placeholder:opacity-100 focus:!border-t-gray-900"
                containerProps={{
                  className: "!min-w-full",
                }}
              />
            </div>

            {/* Category */}
            <div>
              <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                Category
              </Typography>
              <Select
                className="text-darkBlack"
                label="Select Category"
                value={formData?.category}
                onChange={(value) => setFormData((prev) => ({ ...prev, category: value }))}
              >
                {/* <Option >Select Category</Option> */}
                {
                  categoryData?.length == 0 ? <Option>No Category Avalaible</Option> :
                    categoryData?.map((item, index) => (
                      <Option value={item?.name} key={index}>{item?.name || "No category Avalaible"}</Option>
                    ))
                }

              </Select>
            </div>
            <div>
              <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                Brand
              </Typography>
              <Select
                className="text-darkBlack"
                label="Select Brand"
                value={formData?.brand}
                onChange={(value) => setFormData((prev) => ({ ...prev, brand: value }))}
              >
                {/* <Option >Select Brand</Option> */}
                {
                  brandData?.length == 0 ? <Option>No Brand Avalaible</Option> :
                    brandData?.map((itm, index) => (
                      <Option value={itm?.name} key={index}>{itm?.name || "No Brand Avalaible"}</Option>
                    ))
                }
              </Select>
            </div>


            {/* Description */}
            <div>
              <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
                Description (Optional)
              </Typography>
              <Textarea
                rows={7}
                type="textarea"
                placeholder="e.g. This is a white shoe with a comfortable sole."
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                className="!w-full !border-[1.5px] !border-blue-gray-200/90 !border-t-blue-gray-200/90 bg-white text-gray-600 ring-4 ring-transparent focus:!border-primary focus:!border-t-blue-gray-900 group-hover:!border-primary"
                containerProps={{
                  className: "!min-w-full",
                }}
                labelProps={{
                  className: "hidden",
                }}
              />
            </div>
            <div>
  <Typography variant="small" color="blue-gray" className="mb-2 text-left font-medium">
    Top Sale Product
  </Typography>
  <label className="flex items-center">
    <input
      type="checkbox"
      name="topSale"
      checked={formData.topSale === true}  // Check if topSale is 'yes'
      onChange={(e) => {
        setFormData((prev) => ({
          ...prev,
          topSale: e.target.checked ? true : false,  // If checked, set it to 'yes', else ''
        }));
      }}
      className="form-checkbox text-blue-500 focus:ring-blue-300 focus:ring-2 h-8 w-8 rounded border-gray-300 transition duration-200 ease-in-out"
    />
    <Typography variant="small" color="blue-gray" className="block font-medium ml-2">
      {`If this is a Top Sale Product`}
    </Typography>
  </label>
</div>
            {/* Submit Button */}
            <Button className="ml-auto flex justify-end bg-forestFog text-vanillaWhite" type="submit">
              Update Product
            </Button>
          </DialogBody>
        </form>
      </Dialog>
    </>
  );
}